import { render, staticRenderFns } from "./PrivacyThirdParty_202609.vue?vue&type=template&id=649a88b7&scoped=true"
import script from "./PrivacyThirdParty_202609.vue?vue&type=script&lang=js"
export * from "./PrivacyThirdParty_202609.vue?vue&type=script&lang=js"
import style0 from "@/assets/help/document.css?vue&type=style&index=0&id=649a88b7&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649a88b7",
  null
  
)

export default component.exports